import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { HubConnection } from '../service/chatHubService.service';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subscription } from 'rxjs';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { ScrollToBottomDirective } from '../scroll-to-bottom.directive'
import { MatCheckboxChange } from '@angular/material/checkbox';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';


@Component({
  selector: 'app-chat-holder',
  templateUrl: './chat-holder.component.html',
  styleUrls: ['./chat-holder.component.scss']
})
export class ChatHolderComponent implements OnInit {

  @ViewChild('scrollBottom') private scrollBottom: ElementRef;
  @ViewChild('scrollMe') private myScrollContainer: ElementRef;
  @Output() documentViewer = new EventEmitter<boolean>();
  @ViewChild('Input') InputFile: ElementRef;

  currentUser: any;
  organizationId: string;
  databaseId: string;
  responseHolder: any;
  clickEventsubscription: any;
  newChatSubscription: Subscription;
  roomId: any;
  participantDetails: any = [];
  message: string = "";
  isOnetoOne: boolean = false;
  sendButtonShow: boolean = false;
  groupname: string = "";
  imageUrl: string = "";
  LoggedInEmail: string = "";

  messageList: any = [];
  results: any[];

  filepath: any = "";
  fileType: any = "";
  fileName: any = "";
  fileToUpload: any;
  peoples: any[] = [];
  selectedUser: any[] = [];
  selectedUserToDelete:any[] = [];

  existingUsers: any[] = [];
  groupName: string = "";
  users: any[] = [];
  timeout = null;

  DoneButtonShow: boolean = false;
  userListResponseHolder: any;
  chatId: any;


  pageModelData = {
    pageIndex: 0,
    pageSize: 500,
    SearchKey: "",
    databaseID: 0,
    organizationID: 0
  };

  pageIndex: any;
  pageSize: any;
  currentDate: any


  showEmojiPicker = false;
  sets = [
    'native',
    'google',
    'twitter',
    'facebook',
    'emojione',
    'apple',
    'messenger'
  ]
  set = 'twitter';
  isRemove: boolean;
  removedUser: any;
  searchValue: any;
  isDisabled: boolean;
  isEnabled: boolean;
  spinner: boolean;
  isAdd: boolean;
  loggedinEmail: string;

  toggleEmojiPicker() {
    this.showEmojiPicker = !this.showEmojiPicker;
  }

  addEmoji(event) {
    const { message } = this;
    const text = `${message}${event.emoji.native}`;
    this.message = text;
  }

  onFocus() {
    this.showEmojiPicker = false;
  }

  onBlur() {
  }

  scrollToBottom(): void {
    try {
      this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
    } catch (err) { }
  }

  OfficeIDList: any=[];
  myOfficeID: any;
  constructor(private dialog: MatDialog, private loaderService: LoaderService,
    private ChatsignalRconnaction: HubConnection, private toastr: ToastrService,
    private statusConst: StatusConstant, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private _dataSharingService: DataSharingService) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    this.currentUser = jwt_decode(token);
    var offices=JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
    this.OfficeIDList.push(oe.officeID)	
    if(oe.isMyoffice==true)
      this.myOfficeID=oe.officeID;
    });	 
  }

  ngAfterViewInit() {
   // this.scrollbarRef.scrollToBottom();   
    this.newChatSubscription = this.ChatsignalRconnaction.newChatRecived.subscribe(data => {
      if (data.roomId == this.roomId && data.fromUser.email.toLowerCase()!=((sessionStorage.getItem('email')==null || sessionStorage.getItem('email')==undefined)?sessionStorage.getItem('portalemail'):sessionStorage.getItem('email')).toLowerCase()) {
        this.GetChatMessagesListForRoom();
      }
    });
     this.newChatSubscription = this.ChatsignalRconnaction.newChatRecived.subscribe(data => {
      if(data!=null){
        this.GetChatMessagesListForRoom();        
      }
     });
  }

  ngAfterViewChecked() {
    // this.scrollToBottom();
  }

  ngOnDestroy() {
    this.clickEventsubscription.unsubscribe();
   // this.newChatSubscription.unsubscribe();
  }

  assignData() {
    this.roomId = this.participantDetails.id;
    this.groupname = this.participantDetails.roomName;
    this.imageUrl = this.participantDetails.imageUrl;
    this.message = "";
    this.sendButtonShow = false;
    this.isOnetoOne = this.participantDetails.isOnetoOne ?? false;
    this.selectedUser = this.participantDetails.users;

    if (this.isOnetoOne) {
    } else {
      this.groupName = this.participantDetails.roomName;
    }
  }

  ngOnInit(): void {
    this.loggedinEmail=((sessionStorage.getItem('email') == null || sessionStorage.getItem('email') == undefined) ? sessionStorage.getItem('portalemail').toLowerCase() : sessionStorage.getItem('email').toLowerCase());
  
    // this.scrollToBottom();
    this.clickEventsubscription = this._dataSharingService.getSelectedChatParticipant().subscribe((result) => {
      if (result) {
        this.messageList = [];
        this.groupName = "";
        this.participantDetails = result;
        this.roomId = this.participantDetails.id;
        this.groupname = this.participantDetails.roomName;
        this.imageUrl = this.participantDetails.imageUrl;
        this.message = "";
        this.sendButtonShow = false;
        this.isOnetoOne = this.participantDetails.isOnetoOne ?? false;
        this.selectedUser = this.participantDetails.users;

        if (this.isOnetoOne) {
        } else {
          this.groupName = this.participantDetails.roomName;
        }
        this.GetChatMessagesListForRoom();
      }
    });
  }

  cancelUploadFile() {
    this.filepath = "";
    this.fileName = "";
    this.fileType = "";
    if (this.message != "") {
      this.sendButtonShow = true;
    }
    else {
      this.sendButtonShow = false;
    }
  }


  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
    this.addFileManagerFile();
    this.InputFile.nativeElement.value = '';
  }

  addFileManagerFile() {
    this.dialog.closeAll();
    this.loaderService.show();
    let documentType = this.fileToUpload.name.split('.').pop();
    const formData: FormData = new FormData();
    formData.append('roomId', this.roomId);
    formData.append('name', this.fileToUpload.name);
    formData.append('file', this.fileToUpload);
    formData.append('fileType', documentType);
    formData.append('officeID', this.myOfficeID);
    //formData.append("fromUserId", this.currentUser.UID);
    formData.append("email",((sessionStorage.getItem('email')==null || sessionStorage.getItem('email')==undefined)?sessionStorage.getItem('portalemail'):sessionStorage.getItem('email'))) ;


    this.fileName = this.fileToUpload.name;
    this.fileType = documentType;
    this.ChatsignalRconnaction.AddfileAsAttachment(formData).subscribe(response => {
      if (response != undefined) {
        this.loaderService.hide();
        var responseHolder = response;
        if (responseHolder.data != "" && responseHolder.status == this.statusConst.statusSuccess) {
          this.filepath = responseHolder.data;
          this.sendButtonShow = true;
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }



  GetChatMessagesListForRoom() {
    var ReqModel = {
      roomId: this.roomId,
      pageIndex: 0,
      pageSize: 500
    }
    this.ChatsignalRconnaction.GetChatMessagesListForRoom(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.messageList = response.data.messages;
          var groups = new Set(this.messageList.map(item => new Date(item.createdOn).toISOString().slice(0, 10)))
          this.results = [];
          groups.forEach(g =>
            this.results.push({
              dates: g,
              values: this.messageList.filter(i => new Date(i.createdOn).toISOString().slice(0, 10) === g)
            }
            ));

          this.messageList = this.results;
          this._dataSharingService.sendAddAttachmentFile(true);
        } else {
          this.messageList = [];
        }
      } else {
        this.messageList = [];
      }
    });
  }


  onChange(message: string) {
    message = message.replace(/^\s+/, '').replace(/\s+$/, '');
    if ((message != "" && message != undefined && message != null)) {
      if(message!=this.groupName)
        this.message = message;
      this.sendButtonShow = true;
    } else {
      this.sendButtonShow = false;
      if (this.filepath == "") {
        this.sendButtonShow = false;
      }
      else {
        this.sendButtonShow = true;
      }
    }
  }

  onChangegrp(message: string){
    if ((this.groupName != "" && this.groupName != undefined && this.groupName != null) && this.existingUsers.length > 0) {
      this.DoneButtonShow = true;
    }
    else {
      this.DoneButtonShow = false;
    }
  }

  onEnter(event) {
    event.target.value = event.target.value.replace(/^\s+/, '').replace(/\s+$/, '');
    if ((event.target.value != "" && event.target.value != undefined && event.target.value != null) || this.filepath != "") {
      this.message = event.target.value;
      this.send();
      event.preventDefault();
    }
  }
  emptyGuid:any = "00000000-0000-0000-0000-000000000000";
  send() {
    var ReqModel = {
      roomId: this.roomId,
      message: this.message,
      fromUserId: this.emptyGuid,//this.currentUser.UID,
      messageType: 0,
      fileType: this.fileType,
      fileName: this.fileName,
      filePath: this.filepath,
      isOnetoOne: false,
      email:((sessionStorage.getItem('email')==null || sessionStorage.getItem('email')==undefined)?sessionStorage.getItem('portalemail'):sessionStorage.getItem('email'))
    
    }
    this.message = "";
    this.sendButtonShow = false;
    this.ChatsignalRconnaction.CreateChatMessage(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this._dataSharingService.sendAddAttachmentFile(true);
          this._dataSharingService.sendMessageUserOrGroup(this.roomId);
          this.GetChatMessagesListForRoom();
          this.filepath = "";
          this.fileType = "";
          this.fileName = "";
          this.sendButtonShow = false;
        } else {

        }
      } else {
      }
    });
  }

  getShortName(fullName) {
    if(fullName!=undefined)
      {
    var x = fullName.split(' ').splice(0,2).join(' ');
    return x.split(' ').map(n => n[0]).join('');
      }
      return "";
  }

  getShortNameEmail(fullName) {
    var x = fullName.split('@')[0];
    return x;
  }

  openDocumentViewer(message: boolean, document, templateRef: TemplateRef<any>) {
    this._dataSharingService.sendSelectedDocumentForChat(document);
    this.documentViewer.emit(message);
    this.dialog.open(templateRef);
  }

  getCloseDocumentViewer(message: boolean) {
    this.documentViewer.emit(false);
    this.dialog.closeAll();
  }

  close() {
    this.peoples.forEach(e => {
      e.isChecked = false
    });
    this.selectedUser = [];
    this.existingUsers = [];
    this.groupName = "";
    this.pageModelData.SearchKey = "";
    this.dialog.closeAll();
    this.searchValue='';
    this.isEnabled=false;
  }

  clear() {
    this.peoples.forEach(e => {
      e.isChecked = false
    });
    let idsToDelete = this.existingUsers.map(function (elt) { return elt.email; });
    this.selectedUser = this.selectedUser.filter(function (elt) { return idsToDelete.indexOf(elt.email) === -1; });
    //this.selectedUser = [];
    //this.existingUsers = [];
    this.groupName = "";
    this.pageModelData.SearchKey = "";
    this.dialog.closeAll();
    this.searchValue='';
    this.isEnabled=false;
  }


  GetAllRoomsforUser() {
    var ReqModel = {
      //userId:this.currentUser.UID,
      email:((sessionStorage.getItem('email')==null || sessionStorage.getItem('email')==undefined)?sessionStorage.getItem('portalemail'):sessionStorage.getItem('email'))
    }
    this.ChatsignalRconnaction.GetAllRoomsforUser(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.users = response.data;
          if (this.users.length > 0) {
            var firstData = this.users[0];
            this.chatId = firstData.id;
            this.users = response.data;
            this.groupname = firstData.roomName;
            this._dataSharingService.sendSelectedChatParticipant(firstData);
            //this._dataSharingService.sendSelectedChatGroups(this.users);            
          }
        } else {
          this.users = [];
        }
      } else {
        this.users = [];
      }
    });
  }

  SelectUser(user) {
    this.isRemove=true;
    this.removedUser=user;
    let removeIndex = this.selectedUser.findIndex((itm) => itm.email.toLowerCase() === user.email.email.toLowerCase());
    if (removeIndex !== -1) {
      this.selectedUser.splice(removeIndex, 1);      
      let removeExisting = this.existingUsers.findIndex((itm) => itm.email.toLowerCase() === user.email.toLowerCase());
      if (removeExisting !== -1) {
        this.existingUsers.splice(removeExisting, 1);
      }
      this.peoples.forEach(e => {
        if (e.uuid == user.userId) {
          e.isChecked = false
        }
      });
    } else {
    }

    

    if ((this.groupName != "" && this.groupName != undefined && this.groupName != null) && this.selectedUser.length > 0) {
      this.DoneButtonShow = true;
      if(user.isDeleted===null && typeof(user.isDeleted)!==undefined)
      {
        this.DeleteUser(user);
      }
      else{
        this.isRemove=false;
      }

      if(this.existingUsers.length >0 && (this.groupName != "" && this.groupName != undefined && this.groupName != null)){
        this.DoneButtonShow = true;
        this.isAdd = true;
      }else{
        this.DoneButtonShow = false;
        this.isAdd = false;
      }
    }
    else {
      this.DoneButtonShow = false;
    }
  }

  DeleteUser(user){
    var req={
     //userId: user.userId,
     userName: user.userName,
     organizationId: user.organizationId,
     profileImageUrl: user.profileImageUrl,
     email: user.email,
    }
    this.selectedUserToDelete.push(req);
    if(this.selectedUser.length>0){
      let removeIndex = this.peoples.findIndex((itm) => itm.email.toLowerCase() === user.email.toLowerCase());
      if (removeIndex !== -1) {
        this.peoples.find((itm) => itm.email.toLowerCase() === user.email.toLowerCase()).isDeleted = true;      
        this.DoneButtonShow=true;
    }
   }
   var checklastUser= this.peoples.filter((itm) => itm.isDeleted === false);
   if(checklastUser.length==0){
      //this.dialog.closeAll();
      this.DeleteParticipant();
   }
  }

  DeleteParticipant() {
    const message = `Are you sure you want to delete this group participant ?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
     panelClass: 'edituserdetails',
     maxWidth: '1000px',
     maxHeight: '500px',
     data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
         this.loaderService.show();
         var ReqModel={
           roomId: this.roomId,
           user: this.selectedUserToDelete,
           isAdd: false,
           updatedBy:  this.currentUser.UID,
           organisationId: Number(this.organizationId)
         }
         this.loaderService.show();
         this.ChatsignalRconnaction.AddOrRemoveUserFromChatRoom(ReqModel).subscribe((response) => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.loaderService.hide();
              this._dataSharingService.sendDeleteChatGroup(true);
              this.close();
              this.GetAllRoomsforUser();
              this.isRemove=false;
              this.selectedUserToDelete=[];
              this.toastr.success('Group participant remove successfully.', '', {
               timeOut: 3000,
               });
               }else{
               this.close()
               this.loaderService.hide();
               }        
              } else {
               this.close()
               this.loaderService.hide();
             }
           });      
        }
      } catch (e) {
       Observable.throw(e);
     }
   });
   }

  SelectUserFromCheckBox(event: MatCheckboxChange, user) {
    let removeIndex = this.selectedUser.findIndex((itm) => itm.email.toLowerCase() === user.email.toLowerCase());
    if (removeIndex !== -1) {
      this.selectedUser.splice(removeIndex, 1);

      let removeExisting = this.existingUsers.findIndex((itm) => itm.email.toLowerCase() === user.email.toLowerCase());
      if (removeExisting !== -1) {
        this.existingUsers.splice(removeExisting, 1);
      }

      this.peoples.forEach(e => {
        if (e.email.toLowerCase() == user.email.toLowerCase()) {
          e.isChecked = false;
        }
      });
    } else {
      var ReqModel = {
        userId: this.emptyGuid, //user.uuid,
        userName: this.getShortNameEmail(user.email),
        organizationId: user.organizationId,
        profileImageUrl: user.profileImagePath,
        email: user.email,
      }

      this.existingUsers.push(ReqModel);
      this.selectedUser.push(ReqModel);
      this.peoples.forEach(e => {
        if (e.email.toLowerCase() == user.email.toLowerCase()) {
          e.isChecked = true;
        }
      });
    }
    if ((this.groupName != "" && this.groupName != undefined && this.groupName != null) && this.selectedUser.length > 0) {
      this.DoneButtonShow = true;
      this.isAdd = true;
    }
    else {
      this.DoneButtonShow = false;
      this.isAdd = false;
    }

    if(this.existingUsers.length >0 && (this.groupName != "" && this.groupName != undefined && this.groupName != null)){
      this.DoneButtonShow = true;
      this.isAdd = true;
    }else{
      this.DoneButtonShow = false;
      this.isAdd = false;
    }
  }

  startNewGroup(templateRef: TemplateRef<any>) {
    const dialogRef = this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox'
    });
    this.peoples = [];
    this.existingUsers=[];
    this.getPortalEmailUserList(this.pageModelData);
    this.DoneButtonShow = false;
    if (!this.isOnetoOne) {
      this.assignData();
      let idsToDelete = this.existingUsers.map(function (elt) { return elt.email; });
      this.selectedUser = this.selectedUser.filter(function (elt) { return idsToDelete.indexOf(elt.email) === -1; });
    }
  }

  CreateNewGroup() {
    if (!this.isOnetoOne) {
      this.assignData();
      if(this.isAdd)
        this.CreateNewParticipant();
    } else {
      var ReqModel = {
        type: "Room",
        roomName: this.groupName,
        organizationId: Number(this.organizationId),
        createdBy: this.emptyGuid, //this.currentUser.UID,
        users: this.selectedUser,
        recentMessage: "",
        isOnetoOne: false
      }
      this.close();
      this.ChatsignalRconnaction.CreateChatRoom(ReqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.GetAllRoomsforUser();
            this.toastr.success('Group chat created successfully.', '', {
              timeOut: 3000,
            });
          } else {
            this.close();
          }
        } else {
          this.close();
        }
      });
    }

  }

  CreateNewParticipant() {
    var ReqModel = {
      roomId: this.roomId,
      isAdd: true,
      organizationId: Number(this.organizationId),
      updatedBy: this.currentUser.UID,
      user: this.existingUsers,
    }

    this.close();
    this.ChatsignalRconnaction.AddOrRemoveUserFromChatRoom(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          var data = this.responseHolder.data;
          if (data.users != null) {
            this.GetAllRoomsforUser();
            this.toastr.success('Participant added successfully.', '', {
              timeOut: 3000,
            });
          } else {
            this.GetAllRoomsforUser();
            this.toastr.success('Participant added successfully.', '', {
              timeOut: 3000,
            });
          }
        } else {
          this.close();
        }
      } else {
        this.close();
      }
    });
  }

  addNewParticipant(templateRef: TemplateRef<any>) {
    const dialogRef = this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox'
    });
    this.peoples = [];
    this.existingUsers=[];
    this.getPortalEmailUserList(this.pageModelData);
    this.DoneButtonShow = false;
    this.assignData();
  }

  async getUserList(pageData: any) {
    this.pageModelData.pageIndex = pageData.pageIndex;
    this.pageModelData.pageSize = pageData.pageSize;
    this.pageModelData.SearchKey = pageData.SearchKey.trim();
    this.pageModelData.databaseID = Number(this.databaseId);
    this.pageModelData.organizationID = Number(this.organizationId);
    this.pageIndex = pageData.pageIndex;
    this.pageSize = pageData.pageSize;
    if (this.pageModelData.SearchKey != "") {
      const result = await this.ChatsignalRconnaction.GetUsersListForChat(this.pageModelData).toPromise();
      if (result.data.userModel != null) {
        this.userListResponseHolder = result.data.userModel;
      }
      else
      this.userListResponseHolder = [];
      if (this.statusConst.statusSuccess === 200 ) {
        this.userListResponseHolder.map((res) => {
          if (res.email != null) {
            res.email = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.email);
          }
          if (res.userName != null) {
            res.userName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.userName);
          }
          if (res.firstName != null || res.lastName != null) {
            res.firstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.firstName);
            res.lastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.lastName);
            res.name = res.firstName + " " + res.lastName;
          }
          return res;
        });

        this.peoples = result.data.userModel.filter((m) => m.uuid != this.currentUser.UID);
        var idsToDelete = this.selectedUser.map(function (elt) { return elt.email; });
        this.peoples = this.peoples.filter(function (elt) { return idsToDelete.indexOf(elt.email) === -1; });
        this.peoples.forEach(e => {
          e.isChecked = false
        });
        this.pageModelData.pageIndex = result.data.pageIndex;
        this.pageIndex = result.data.pageIndex;
        this.pageSize = pageData.pageSize;
      } else {
        this.peoples = [];
      }
    }
    else {
      this.peoples = [];
    }
  }

  async getPortalEmailUserList(pageData: any) {
    this.pageModelData.pageIndex = pageData.pageIndex;
    this.pageModelData.pageSize = pageData.pageSize;
    this.pageModelData.SearchKey = pageData.SearchKey.trim();
    this.pageModelData.databaseID = this.databaseId==undefined? 0:Number(this.databaseId);
    this.pageModelData.organizationID =this.organizationId==undefined?0: Number(this.organizationId);
    this.pageIndex = pageData.pageIndex;
    this.pageSize = pageData.pageSize;
    if(this.pageModelData.SearchKey!=""){
    const result = await this.ChatsignalRconnaction.getPortalEmailUserList(this.pageModelData).toPromise();    
    if(result.data.userModel!=null)
    this.userListResponseHolder = result.data.userModel;
    else
    this.userListResponseHolder=[];
    if (200 === this.statusConst.statusSuccess){
      this.peoples=result.data.userModel;
         
      this.pageModelData.pageIndex = result.data.pageIndex;
      this.pageIndex = result.data.pageIndex;
      this.pageSize = pageData.pageSize;    

    } else {
     this.peoples=[];
    }
  }
  else{
    this.peoples=[];
   }
  }

  SetSearchValue(val){
    if(val && val.length>2){
      this.searchValue=val;
      this.isEnabled=true;
    }
    else{
      this.peoples = [];
      this.searchValue='';
      this.isEnabled=false;
    }       
  }

  Search() {
    if (this.searchValue != '') {
      this.spinner=true;

      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.pageModelData.SearchKey = this.searchValue.trim();
        this.getUserList(this.pageModelData);
        this.spinner=false;
      }, 500);
    } else {
      this.peoples = [];
      this.spinner=false;
    }
  }

  SearchEmail() {
    if(this.searchValue!= ''){
    this.spinner=true;
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.pageModelData.SearchKey=this.searchValue.trim();    
      this.getPortalEmailUserList(this.pageModelData);
    }, 500);
  }else{
    this.pageModelData.SearchKey="";    
    this.getPortalEmailUserList(this.pageModelData);
    this.spinner=false;
  }
}

}
